import React from 'react';
import styled from 'styled-components';
import { Badge as AntdBadge } from 'antd';
import { BadgeProps as AntdBadgeProps } from 'antd/lib/badge';
import { buildCssLengthProps } from 'utils';
import theme from '../theme';

// The original color is omitted because it forces the badge to be small
// The original offset is omitted because it only works for small badges
export type BadgeProps = Omit<AntdBadgeProps, 'color' | 'offset'> & {
  color?: 'primary' | 'danger' | 'success' | 'gray8';
  offset?: [number, number];
  defaultAlign?: boolean;
  dotSize?: 'default' | 'large';
};

const StyledBadge = styled(AntdBadge)<{
  dot?: boolean;
  $dotSize: string;
  $color: string;
  $offset: [number, number];
  $defaultAlign: boolean;
}>`
  && > sup {
    ${({ dot }) => !dot && 'padding: 0 6px'};
    ${({ dot, $dotSize }) =>
      dot &&
      $dotSize &&
      buildCssLengthProps([
        ['width', $dotSize],
        ['height', $dotSize],
      ])};
    font-weight: bold;
    background-color: ${({ $color }) => $color};
    ${({ $defaultAlign }) => !$defaultAlign && `line-height: 1.8`};

    ${({ $offset }) => `
      margin-right: ${-$offset[0]}px;
      top: ${$offset[1]}px;
    `}
  }
`;

export const Badge: React.FC<BadgeProps> = ({
  color = 'primary',
  offset = [0, 0],
  defaultAlign = false,
  dotSize = 'default',
  ...props
}) => (
  <StyledBadge
    $color={theme.getColor(color)}
    $offset={offset}
    $defaultAlign={defaultAlign}
    $dotSize={`calc(${theme.badgeDotSize} + ${dotSize === 'large' ? 2 : 0}px)`}
    {...props}
  />
);

export default styled(Badge)``;
